import socketIOClient from "socket.io-client";
export const socket = socketIOClient("https://weerdy-socket.herokuapp.com");
//export const socket = socketIOClient("https://weerdy-api.herokuapp.com/");
